import getBlockSendersConfirmTitleAndSubtext from './getBlockSendersConfirmTitleAndSubtext';
import blockSenderService from '../../services/blockSenderService';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

/**
 * Shows the confirm dialog before sending out the block service call
 * @param mailboxes to block
 * @param blockActionCallback to be called upon sending out the service call
 */
export default async function blockLastSendersHelper(
    mailboxes: EmailAddressWrapper[],
    blockActionCallback: () => void
) {
    if (!mailboxes) {
        // Do nothing in case of invalid mailboxes,
        // i.e mailboxes is null when user tries to block self
        return;
    }

    const [title, subtext] = getBlockSendersConfirmTitleAndSubtext(mailboxes);
    const confirmResponse = await confirm(title, subtext);
    if (confirmResponse !== DialogResponse.ok) {
        return;
    }

    try {
        blockSenderService(mailboxes);
    } catch (error) {
        // VSO 19006: Handle service error caused by block
    }

    blockActionCallback();
}
